  class MetricsMainFunnel {
    
    static openFunnel(eventName, currentBox){
      gtag("event", "sub_funnel_v4__open", { 
        event_category: "open_screen-" + eventName, 
        event_label: "curr_page-" + window.location.pathname, 
        event_value: "",
        current_box: currentBox == null ? 'empty' : currentBox 
      });
    }

    static closeFunnel(eventName, currentBox){
      gtag("event", "sub_funnel_v4__close", { 
        event_category: "close_screen-" + eventName, 
        event_label: "curr_page-" + window.location.pathname, 
        event_value: "",
        current_box: currentBox == null ? 'empty' : currentBox 
      });
    }

    static nextSectionFunnel(selectedValue, currentStep , currentBox){
      gtag("event", "sub_funnel_v4__step", { 
        event_category: "selected-" + selectedValue, 
        event_label: "screen_completed-" + currentStep, 
        event_value: "",
        current_box: currentBox == null ? 'empty' : currentBox 
      });
    }

    static variantSectionFunnel(selectedValue , currentBox){
      gtag("event", "sub_funnel_v4__variant", { 
        event_category: "selected-" + selectedValue, 
        event_label: "screen_completed-" + window.location.pathname , 
        event_value: "",
        current_box: currentBox == null ? 'empty' : currentBox 
      });
    }
  }

  class UseCaseStyling {
      
      static resetSizesCustom(containerId) {
          const elements = document.querySelectorAll(`#${containerId} .selectedBoxStyle`);
          UseCaseStyling.unhideAllElements(elements);
      }
      static unhideAllElements(elements) {
          for (const element of elements) {
              element.classList.remove('selectedBoxStyle');
          }
      }

      static resetSizesAll() {
        // Query all the elements from the predefined containers at once
        const selectors = ['#eby-sub4-size-bra .selectedBoxStyle', '#eby-sub4-size-panty-bra .selectedBoxStyle', '#subs-size-01 .selectedBoxStyle'];
        const elements = document.querySelectorAll(selectors.join(', '));
        UseCaseStyling.unhideAllElements(elements);
      }

      static resetWindowImg(){
        const customPanty = document.querySelectorAll('#eby-sub4-custom-box-product .eby-subs-custom-box-color-item');
        const customBra = document.querySelectorAll('#eby-sub4-custom-box-product-one-bra .eby-subs-custom-box-color-item');
        const customSet = document.querySelectorAll('#eby-sub4-custom-box-product-set .eby-subs-custom-box-color-item');

        UseCaseStyling.removeSrcImg(customPanty, customBra, customSet)
      }

      static removeSrcImg(...elemsArrs){
        elemsArrs.forEach(elemsArr => {
            elemsArr.forEach(elem => {
                // Check if an image exists within the element
                if (elem.querySelector('img')) {
                    // Reset the inner HTML if an image is found
                    elem.innerHTML = '';
                }
            });
        });
      }

      static removeAllHighlights(){
        const elements = document.querySelectorAll('#subsc40-wrapper .selectedBoxStyle');
        // Iterate through each element and remove the 'selectedBoxStyle' class
        elements.forEach(element => {
            element.classList.remove('selectedBoxStyle');
        });
      }
  }

  class FilterGrid {
    constructor(store){
      this.store = store;
      this.grid = document.querySelectorAll('.eby-subs-custom-box-grid-item');
      this.gridSetPanty = document.querySelectorAll('#custom-box-grid-setPantyOnly .eby-subs-custom-box-grid-item');
      this.gridSetBra = document.querySelectorAll('#custom-box-grid-setBraOnly .eby-subs-custom-box-grid-item');
      this.runChangeUpdate = this.updateFilter.bind(this);
      this.runChangeUpdateSet = this.updateFilterSet.bind(this);
      this.runChangeUpdate();
      this.runChangeUpdateSet()
    }

    runPantyFilter(style){
      if(this.grid){
        this.grid.forEach((el) => {

          const elementStyle = el.dataset.prodstyle
          
          if(style === 'shop_all') {
            el.classList.remove('hide');
          } else if(elementStyle !== style){
            el.classList.add('hide');
          } else {
            el.classList.remove('hide');
          }
        });
      }
    }
    runSetFilter(style, gridSet){
      if(gridSet){
        gridSet.forEach((el) => {

          const elementStyle = el.dataset.prodstyle
          
          if(style === 'shop_all') {
            el.classList.remove('hide');
          } else if(elementStyle !== style){
            el.classList.add('hide');
          } else {
            el.classList.remove('hide');
          }
        });
      }
    }
    
    updateFilter(){
      const pantyElement = document.querySelector('#underwear-types');
      if(pantyElement){
        pantyElement.addEventListener('change', () => {
          //this.updateTextTitle('panty');
          const selectedValue = pantyElement.value; 
          this.runPantyFilter(selectedValue);
        });
      }

      const braElement = document.querySelector('#underwear-types-bra');
      if(braElement){
        braElement.addEventListener('change', () => {
          this.updateTextTitle('bra');
          const selectedValue = braElement.value; 
          this.runPantyFilter(selectedValue);
        });
      }
    }

    updateFilterSet(){
      const braElement = document.querySelector('#underwear-types-set-bra');
      
      if(braElement){
        braElement.addEventListener('change', () => {
          const selectedValue = braElement.value; 
          this.runSetFilter(selectedValue, this.gridSetBra);
        });
      }

      const pantyElement = document.querySelector('#underwear-types-set-panty');
      if(pantyElement){
        pantyElement.addEventListener('change', () => {
          const selectedValue = pantyElement.value; 
          this.runSetFilter(selectedValue, this.gridSetPanty);
        });
      }
    }

    removeCircle(store, elementId, index){
      const myImage = document.querySelectorAll(`#${elementId} .eby-subs-custom-box-color-item`);
      
      myImage[index].innerHTML = '';

      store.dispatch({
        type: 'REMOVE_PRODUCTS',
        payload: indexRemove
      });
    }
  }

  class UseCaseFunnelToBoxData{
    constructor (stepTracker, store) {  
      this.store = store;

      this.SWH = "46033961004"; // use sub wh
      this.ECWH = "46033928236"; // use ecomm wh
    }

    initPreloader(toggle) {
      if (!!toggle) {
        jQuery('body').addClass('velaCartAdding');
      } else {
        jQuery('body').removeClass('velaCartAdding');
      }
    }
    
    getSortedCollectionByStock(stockLib, prdLib) {
      let self = this;
      let stockProdLibrary = stockLib.reduce(function (acc, stockData) {
        if (stockData.location_id === +self.SWH) {
          //console.log(':: inventory found ::', stockData.inventory_item_id);
          acc[stockData.inventory_item_id] = stockData.available;
        }
        return acc;
      }, {});
  
      return prdLib.map(function (prd, index) {
        prd.availQty = stockProdLibrary[prd.inventory_item_id];
        return prd;
      });
    }

    getProducts(){
      const self = this;
      const state = this.store.getState();
      
      return Promise.all([
        jQuery.getJSON('https://shop.join-eby.com/collections/first-box-'+'mx-nu-quarterly'+'-assortment.json', function(data) {
          console.log(":: collection id pulled ::", data);
          
          if (!!data.collection) {
              return data;
          } else {
            console.log( ":: stock pull data missing ::", data);
          }
        })
        .fail(function(error) {
          console.log( ":: stock api pull :: FAILURE ::", error.message);
        })
      ])
      .then((response) => {
          // make api request to get products in my size and ready them for my cart
          // let sizesKeyToCheck = dataPayload['pantysizeGroup'] + "::" + dataPayload['brasizeGroup'] + "::xs";
          // console.log(':: sizesKeyToCheck ::', sizesKeyToCheck);
          
          return Promise.all([
            jQuery.ajax({
              type: "POST",
              crossDomain : true,
              url: window.APIDomain+window.otherAPI+"eby-coreHelperSubscription.php",
              data: { data: {
                "variantOptsVals": 'md::xs::xs',
                "collectionId": response[0].collection.id,
                "warehouseKey" : "sub"
              }},
              beforeSend: function() {
                  self.initPreloader(true);
              },
              dataType: 'json',
              headers: {
                  'Authorization': 'Bearer ddd345d2498c7717a7bbbe86d9d145dc',
                  'Access-Control-Allow-Origin': '*'
              },
              success: function(data){
                console.log("::stockcheck success::", data);
                self.initPreloader(false);

                if(!!data){
                  // combine data into one pool
                  let stockProdLibrary = self.getSortedCollectionByStock(
                    data.inventoryHealthcheck,
                    data.prodInventoryData
                  );

                  M.toast({html: 'Your new box is ready!', classes: 'ebyAtcAlert success'});
                  self.store.dispatch({
                    type: 'ADD_CURATED',
                    payload: stockProdLibrary
                  });
                  const myState = self.store.getState();
                  
                  return stockProdLibrary;
                }
              },
              error: function(xhr, text) {
                console.log("::stockcheck failure::", {text : text,xhr : xhr});
                // box is out of stock
                self.initPreloader(false);
                M.toast({html: 'Subscription could not be loaded. Please try again.', classes: 'ebyAtcAlert error'});
              }
            })
          ]);
        })
        .catch(function (data) {
          console.log(":: curation promise pull :: FAILURE", data);
        });
    }

    sendPayload(){
      const self = this;
      document.querySelector('#submitSubscription4').addEventListener('click', function(event){
        event.preventDefault();
        self.getProducts()
        const myState = self.store.getState();
        console.log('ADD Curated to products array',myState);

        self.addClassicPantyBox();

        document.getElementById('subsc40-wrapper').style.display = 'none';
      })
    }

    addClassicPantyBox (prdData) {
      let self = this;

      let membershipBoxData = {"attributes":{"has_curated_membership":"true"},"items":[{"quantity":1,"id":34835570589740,"properties":{"_included_in_membershipbox":true,"_product_type":"Sub Subscription","Shipping Option":"pickup Subscription WH"}},{"quantity":1,"id":41463975673900,"properties":{"_included_in_membershipbox":true,"_product_type":"Sub Subscription","Shipping Option":"pickup Subscription WH"}},{"quantity":1,"id":34835483918380,"properties":{"_included_in_membershipbox":true,"_product_type":"Sub Subscription","Shipping Option":"pickup Subscription WH"}},{"quantity":1,"id":41605329780780,"properties":{"_tiertwo_sub_price_enabled":"true","Shipping Option":"pickup Subscription WH","_product_type":"Main Subscription","_shipping_interval_unit_type":"month","_box_pref":"Classic Panty Subscription Box - 3x / xs","_box_measurements":"3x / xs - null, null","_box_styles":"full_coverage","_box_colors":"mixed_bold","box_perk":"Classic Panty Subscription Box","_perk_key":"cc:fc","_shipping_interval_frequency":3,"tiertwo_sub_price":22.5,"_subscription_ids":"41605329780780,34835483918380,41463975673900,34835570589740"}}]}
      self.initPreloader(true);
      
      // add to cart
      return Promise.all([
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: membershipBoxData,
          dataType: 'json',
          success:function(data) {
            console.log(':: membership box and prods added to cart ::',{data: data});
            self.initPreloader(false);
      
            // turn off loaders
            M.toast({html: 'EBY Subscription added to cart!', classes: 'membershipPopupAlert success'});
            window.loadCart();
            vela.RightDrawer.open();
      
            let boxProdObj = data.items.reduce(function(acc,item){if(item.product_type == "Subscription Box"){acc.push(item);}return acc;},[])[0];

            return boxProdObj;
          },
          error: function(xhr, text) {
            console.log("::EbySubscriptionBox addToCart:: FAILURE", {
              text : text,
              xhr : xhr
            });
            if (!!xhr.responseJSON) {
              alert(xhr.responseJSON.description);
            }
      
          }
        })
      ]).catch((error) => {
        console.log('::addClassicPantyBox:: FAILURE', error.message);
      });
    }

  }
  /**
    * ControllerElementStyle
    * 
    * A utility controller that manages styles of elements based on user interactions.
    * It specifically adds or removes the 'selectedBoxStyle' class to indicate active or inactive states.
  */
  class ControllerElementStyle {
    static showElementTriggered(componentId) {
      const component = document.getElementById(componentId);
      if (component) {
        component.classList.add('selectedBoxStyle');
      }
    }

    static hideElementTriggered(componentId) {
      const component = document.querySelector('#'+componentId + ' .selectedBoxStyle');
      if (component) {
        component.classList.remove('selectedBoxStyle');
      }
    }
    
    static showElemSizeTriggered(selectElem) {
      if (selectElem) {
        selectElem.classList.add('selectedBoxStyle');
      }
    }

    static hideElemSizeTriggered(selectElem) {
      const component = document.querySelector(selectElem);
      if (component) {
        component.classList.remove('selectedBoxStyle');
      }
    }

    static newShowElemSizeTriggered(selectElem) {
      if (selectElem) {
        selectElem.classList.add('selectedBoxStyle');
      }
    }

    static newHideElemSizeTriggered(selectElem) {
      if (selectElem) {
        selectElem.classList.remove('selectedBoxStyle');
      }
    }
  }
  /*
    * The UpdatePaginationUi setups the pagination 
  */
  class UpdatePaginationUi{
    constructor(store){
      this.store = store
      this.pageElem = document.querySelector('#ebySubs4Pagination');
      this.store.subscribe(() => this.updateFromState());
    }
  
    updateFromState() {
      const box = this.store.getState().currentBox
      const { currentPage, totalPages } = this.store.getState().pagination;
      
      if( (box instanceof EbyBraBox || box instanceof EbySetBox) && currentPage > 3){
        this.pageElem.textContent = `${currentPage - 1} of ${totalPages}`;
      } else {
        this.pageElem.textContent = `${currentPage} of ${totalPages}`;
      }
    }
    
    updateFromStatePrev() {
      const box = this.store.getState().currentBox
      const { currentPage, totalPages } = this.store.getState().pagination;
      
      if( (box instanceof EbyBraBox || box instanceof EbySetBox) && currentPage > 2){
        this.pageElem.textContent = `${currentPage - 1} of ${totalPages}`;
      } else {
        this.pageElem.textContent = `${currentPage} of ${totalPages}`;
      }
    }
  }
  /**
    * ControllerNextComponent
    * 
    * A controller to handle navigation to the next component in a sequence.
    * It can activate or deactivate a "next" button based on certain criteria.
  */
  class ControllerNextComponent{
    constructor(componentId){
      this.nextClassSelector = document.querySelector('#'+componentId + ' .controllerNextButton');
      this.styleSelector = 'disabledButtonGray';
      //this.UpdatePaginationUi = new UpdatePaginationUi();
    }

    goNext(nextComponentId, currentId){
      this.nextClassSelector.addEventListener('click', () => {
        // Handle next steps
        ControllerComponent.hideComponent(currentId);
        ControllerComponent.showComponent(nextComponentId);
      });
    }

    activateButton(){
      if (this.nextClassSelector) {
        this.nextClassSelector.classList.remove(this.styleSelector);
      }
    }

    disabledButton(){
      if (this.nextClassSelector) {
        this.nextClassSelector.classList.add(this.styleSelector);
      }
    }
  }  
  /**
    * PlanSelectionController
    * 
    * This controller is responsible for managing the selection of a subscription plan. 
    * It handles the user's selection, updates the UI accordingly, and keeps track 
    * of the currently selected plan.
  */
  class PlanSelectionController {
    constructor(stepTracker, store) {
      this.stepTracker = stepTracker;
      this.store = store;
      //this.unsubscribe = this.store.subscribe(() => this.handleStateChange());
      this.boundPlanClickEvent = null; // Placeholder for the bound event handler
      this.elementClicked = null;
    }

    setSteps(elemClicked){
      ControllerElementStyle.hideElementTriggered(this.stepTracker.getCurrentStep());
      ControllerElementStyle.newShowElemSizeTriggered(elemClicked);
    }

    planClickEvent(event, clickedId, nextComponentId){
      if(event.target.type === 'radio'){
        return
      }

      event.preventDefault();
      event.stopPropagation();
      
      const currentTarget = event.target.closest(nextComponentId)
      const inputElement = currentTarget.querySelector('input');
      
      this.setSteps(currentTarget);

      if (inputElement) {
        this.store.dispatch({ type: 'RESET_SET_BRA_OPT' });
        this.store.dispatch({type: 'RESET_PANTY_OPT'});
        this.store.dispatch({type: 'RESET_SIZES'});
        this.store.dispatch({type: 'RESET_COLLECTIONP'});
        this.store.dispatch({type: 'RESET_CBOPTS'});
        
        this.store.dispatch({
          type: 'SET_BOX_TYPE',
          payload: {boxType: inputElement.value, currentBox:inputElement.value}  
        });
        this.store.dispatch({
          type: 'RESET_PRODUCTS',
          payload: {boxType: inputElement.value, currentBox:inputElement.value}  
        });
        const nextComponent = currentTarget.dataset.next_comp

        ControllerComponent.hideComponent(this.stepTracker.getCurrentStep());
        ControllerComponent.showComponent(nextComponent);
          
        this.stepTracker.goToStep(nextComponent, inputElement.value);

        if( inputElement.value === "set_box"){
          this.handleStyleClickEvent()
        }
      } else {
        console.error('No input in plan', event.target);
      }

    }
    handlePlanSelection(clickedId, nextComponentId) {
      const element = document.querySelector('#eby-sub4-plan ' + clickedId);

      // Remove the old event listener if it exists.
      if(this.elementClicked && this.boundPlanClickEvent) {
        this.elementClicked.removeEventListener('click', this.boundPlanClickEvent);
      }
      
      if(element){
        // Bind the event handler and store the reference so it can be removed later.
        this.boundPlanClickEvent = (event) => this.planClickEvent(event, clickedId, nextComponentId);
        element.addEventListener('click', this.boundPlanClickEvent);
        // Store the current element as well.
        this.elementClicked = element;
      } else {
        console.error('Element with id:', clickedId, 'not found.');
      }
    }
    handleStyleClickEvent() {
        const self = this;
      
        const productControllerSet = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-here', self.store);
        const productControllerSetPanty = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-panty-here', self.store);
        productControllerSet.renderProductsSet();  
        productControllerSetPanty.renderProductsSetPanty();
        
        self.store.dispatch({
          type: 'SET_STYLES',
          payload: "set_custom"
        });
    }
  }
  /**
    * StyleSelectionController
    * 
    * This controller class is designed to handle the selection of a style for the chosen subscription box.
    * Upon a style selection, it updates the chosen box with the selected style and controls 
    * the UI flow for advancing to the next component.
  */
  class StyleSelectionController {
    /**
      * Constructor initializes the StyleSelectionController with a given step tracker and plan controller.
      * 
      * @param {ControllerStepStack} stepTracker - The controller responsible for tracking the current UI step.
      * @param {Store} Store - The controller responsible for handling plan selection.
      * @param {toggleController} toggleController - The controller responsible for toggleing the style.
    */
    constructor(stepTracker, store) {
      this.stepTracker = stepTracker;
      this.store = store;
      // subscribe to store changes
      this.unsubscribe = this.store.subscribe(() => this.handleStateChange());
      this.currentElement = null;
      this.handleStyleClickEvent = this.handleStyleClickEvent.bind(this); 
      //this.toggleController = new ControllerToggle('eby-subs-toggle-size-bras', 'eby-subs-toggle-size-panty');
    }

    handleStyleSelection(clickedId, nextComponentId) {
      const self = this;

      const clickedElement = document.querySelector(clickedId);
      if (clickedElement) {
          clickedElement.addEventListener('click',(event) => 
            this.handleStyleClickEvent(event, clickedId, nextComponentId));
          this.currentElement = clickedElement
      } else {
        console.error('No click event found for ', clickedId)
      }

    }

    handleStyleClickEvent(event, clickedId, nextComponentId) {
      if(event.target.type === 'radio'){
        return
      }
      event.stopPropagation();
      
      const currentTarget = event.target.closest(nextComponentId);
      const self = this;

      ControllerElementStyle.hideElementTriggered(this.stepTracker.getCurrentStep());
      ControllerElementStyle.newShowElemSizeTriggered(currentTarget);
      
      // get value from html element
      const inputElement = currentTarget.querySelector('input');

      if (inputElement) {

        if(inputElement.value === 'set_custom'){
          const productControllerSet = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-here', self.store);
          const productControllerSetPanty = new ControllerCustomProduct(window.location.origin + '/collections/test-custom-set-subscription/products.json?limit=200', 'custom-box-insert-all-bra-set-panty-here', self.store);
          productControllerSet.renderProductsSet();  
          productControllerSetPanty.renderProductsSetPanty();
          
        } else if(inputElement.value === 'custom'){
          const productController = new ControllerCustomProduct(window.location.origin + '/collections/first-box-cc-cu-mx-assortment-2/products.json?limit=200', 'custom-box-insert-all-here', self.store);
          productController.renderProducts();
          this.store.dispatch({
            type: 'SET_BOX_TYPE',
            payload: {boxType : 'classic_box', currentBox: 'classic_box_custom'}
          });
          
        } else if(inputElement.value === 'bra-custom'){
          const productControllerBra = new ControllerCustomProduct(window.location.origin + '/collections/first-box-cc-cu-mx-assortment-2/products.json?limit=200', 'custom-box-insert-all-bra-here', self.store);
          productControllerBra.renderProductsSet();
        } 
        
        if (inputElement.getAttribute('data-boxdata-type') === 'box_choice') { // new qualifer = data-boxdata-type = box_choice | bra_pref | panty_pref
            self.store.dispatch({
              type: 'SET_STYLES',
              payload: inputElement.value
            });
          } else if (inputElement.getAttribute('data-boxdata-type') === 'bra_pref'){
            self.store.dispatch({
              type: 'SET_BRA_OPT',
              payload: inputElement.value
            });
          } else {
            self.store.dispatch({
              type: 'SET_PANTY_OPT',
              payload: inputElement.value
            });
          }
        const nextComponent = currentTarget.dataset.next_comp

        ControllerComponent.hideComponent(this.stepTracker.getCurrentStep());
        ControllerComponent.showComponent(nextComponent);
        
        this.stepTracker.goToStep(nextComponent, inputElement.value);
        this.currentElement.removeEventListener('click', this.handleStyleClickEvent);
      } else {
        console.error('No input in style', event.target)
      }
    }

    handleStateChange() {
      const state = this.store.getState();
    }
    
    removeStyleSelection() {
      if (this.clickedElement) {
        this.clickedElement.removeEventListener('click', this.styleClickHandler.bind(this), true);
      }
    }
  }
  /**
    * SizeSelectionController
    * 
    * The SizeSelectionController manages the selection of sizes for different subscription box plans.
    * It's responsible for updating the UI upon a size selection, moving the process
    * to the next step, and updating the current box's size.
  */
  class SizeSelectionController {
    /**
      * Constructs the SizeSelectionController with the necessary trackers and controllers.
      * 
      * @param {ControllerStepStack} stepTracker - Responsible for tracking the current step in the UI flow.
      * @param {Store} Store  - Main state managment object.
    */
    constructor(stepTracker, store) {
      this.stepTracker = stepTracker;
      this.store = store;
      this.onSizeBoxClick = this.onSizeBoxClick.bind(this);
      this.onSizeBoxClickBra = this.onSizeBoxClickBra.bind(this);
      this.onSizeBoxClickSet = this.onSizeBoxClickSet.bind(this);

      this.cupSelect = [];
      this.cupSizeSelect = [];
      this.pantySizeSelect = [];
      this.sizeArrays = [this.cupSelect, this.cupSizeSelect, this.pantySizeSelect];

      this.setFlag = false
    }
    /**
     * Sets up the event listener for Bra size selection and manages subsequent UI and data updates.
     *
     * @param {Array} arrSizeSelect - Array of selectors indicating the clickable size elements.
     * @param {Array} sizeParent - Parent elements holding the size selections.
     * @param {string} containerId - The ID of the container holding size selection elements.
     * @param {string} nextStepId - The ID of the next UI component to be shown.
    */
    handleSizePantySelection(arrSizeSelect, boxType, containerId, nextStepId) {
        const sizeContainer = document.getElementById(containerId);
        
        if (sizeContainer) {
            const sizeBoxes = sizeContainer.querySelector('.styleBoxSizePantyCustom ');
            sizeBoxes.addEventListener('click',(event) => this.onSizeBoxClick(event, '.size-panty-custom-box-select', nextStepId), true);
        }
    }
    handleSizeSelection(arrSizeSelect, sizeParent, containerId, nextStepId) {
      const sizeContainer = document.getElementById(containerId);

      if (sizeContainer) {
    
        const sizeCup = sizeContainer.querySelectorAll('.styleBoxSizeCup');
        const sizeCupMeasure = sizeContainer.querySelectorAll('.styleBoxCupBra');

        this.addEventToBoxBra(sizeCup[0],'.size-bra-select', 'cup');
        this.addEventToBoxBra(sizeCupMeasure[0], '.size-bra-measure', 'size');
      }
    }
    handleSizeSetSelection(arrSizeSelect, boxType, containerId, nextStepId) {
      const sizeContainer = document.getElementById(containerId);
      
      if (sizeContainer) {
        
        const sizeBoxes = sizeContainer.querySelectorAll('.styleBoxSizeCupSet');
        const cubBoxes = sizeContainer.querySelectorAll('.styleBoxCupBraSet');
        const pantyBoxes = sizeContainer.querySelectorAll('.styleBoxSizePantySet');
        
        this.addEventToBoxSet(sizeBoxes[0],  '.size-bra-panty-select', 'cup');
        this.addEventToBoxSet(cubBoxes[0],   '.size-bra-panty-select', 'size');
        this.addEventToBoxSet(pantyBoxes[0], '.size-panty-set-select', 'panty');
      }
    }
    addEventToBoxSet(boxArray, boxType, type){
        boxArray.addEventListener('click',(event) => this.onSizeBoxClickSet(event, boxType, type), true);
    }    
    addEventToBoxBra(boxArray, boxType, type){
        boxArray.addEventListener('click',(event) => this.onSizeBoxClickBra(event, boxType, type), true);       
    }
    onSizeBoxClick(event, boxType, nextStepId) {
        if(event.target.type === 'radio'){
          return
        }
        if(!this.setFlag){
          this.resetSizeSelections();
        }
        event.stopPropagation();
        let targetElement = event.target.closest(boxType);

        ControllerElementStyle.hideElementTriggered('subs-size-01');
        ControllerElementStyle.newShowElemSizeTriggered(targetElement);
                
        let sizeSelectionArray;
        sizeSelectionArray = this.pantySizeSelect;
         
        const inputElement = targetElement.querySelector('input');
        
        if (inputElement) {
            if(inputElement.dataset.pantysize){
                if(sizeSelectionArray.indexOf(inputElement.dataset.pantysize) == -1 || sizeSelectionArray.indexOf(inputElement.value) == -1){
                  sizeSelectionArray.push(inputElement.dataset.pantysize);
                  sizeSelectionArray.push(inputElement.value);

                  const currState = this.store.getState();
                  MetricsMainFunnel.variantSectionFunnel(inputElement.value, currState.boxType);
                }
            }
            this.store.dispatch({ type: 'RESET_PRODUCTS' });
            UseCaseStyling.resetWindowImg();
        } else {
            console.error('No input in Size for Bra or Panty')
        }
        this.sizeGoNextStep(nextStepId);
        event.currentTarget.removeEventListener('click', this.onSizeBoxClick)
    }
    onSizeBoxClickSet(event, boxType, type){
        if(event.target.type === 'radio'){
          return
        }
        if(!this.setFlag){
          this.resetSizeSelections();
        }
        event.stopPropagation();
        let targetElement = event.target.closest(boxType);
        
        const parentTargetChildrens = targetElement.parentElement.children;

        // Loop through the children and remove the class 'selectedBoxStyle' if it exists
        for (let i = 0; i < parentTargetChildrens.length; i++) {
            if (parentTargetChildrens[i].classList.contains('selectedBoxStyle')) {
                parentTargetChildrens[i].classList.remove('selectedBoxStyle');
                continue;
            }
        }
        //ControllerElementStyle.newHideElemSizeTriggered(targetElement);
        ControllerElementStyle.newShowElemSizeTriggered(targetElement);

        let sizeSelectionArray;
        switch(type) {
            case 'cup':
                sizeSelectionArray = this.cupSelect;
                break;
            case 'size':
                sizeSelectionArray = this.cupSizeSelect;
                break;
            case 'panty':
                sizeSelectionArray = this.pantySizeSelect;
                break;
            default:
                console.error('Invalid type for size selection');
                return; // Exit the function early if the type is invalid
        }

        const inputElement = targetElement.querySelector('input');
        
        if (inputElement) {
            if(inputElement.dataset.pantysize){
                if(sizeSelectionArray.indexOf(inputElement.dataset.pantysize) == -1 || sizeSelectionArray.indexOf(inputElement.value) == -1){
                  sizeSelectionArray.push(inputElement.dataset.pantysize);
                  sizeSelectionArray.push(inputElement.value);
                }
            } else {
                if(sizeSelectionArray.indexOf(inputElement.value) == -1){
                    sizeSelectionArray.push(inputElement.value);
                    if(sizeSelectionArray.length > 1){
                      sizeSelectionArray.shift();
                    }
                   // debugger
                }              
            }
            this.store.dispatch({ type: 'RESET_PRODUCTS' });
            UseCaseStyling.resetWindowImg();
        } else {
            console.error('No input in Size for Bra or Panty')
        }
        
        this.sizeGoNextStepSet();
    }
    onSizeBoxClickBra(event, boxType, type) {
        if(event.target.type === 'radio'){
          return
        }
        if(!this.setFlag){
          this.resetSizeSelections();
        }
      
        event.stopPropagation();  
        let targetElement = event.target.closest(boxType);

        if (targetElement) {
          ControllerElementStyle.newHideElemSizeTriggered(targetElement);
          ControllerElementStyle.newShowElemSizeTriggered(targetElement);

          const inputElement = targetElement.querySelector('input');

          let sizeSelectionArray;
          switch(type) {
              case 'cup':
                  sizeSelectionArray = this.cupSelect;
                  break;
              case 'size':
                  sizeSelectionArray = this.cupSizeSelect;
                  break;
              default:
                  console.error('Invalid type for size selection');
                  return; // Exit the function early if the type is invalid
          }

          if (inputElement) {
            if(sizeSelectionArray.indexOf(inputElement.value) == -1){

              sizeSelectionArray.push(inputElement.value);
            }

            this.store.dispatch({ type: 'RESET_PRODUCTS' });
            UseCaseStyling.resetWindowImg();
          } else {
            console.error('No input in size bra', event.target);
          }
          this.sizeGoNextStepBra();
        }
    }
    /**
       * Handles the UI and data updates after size selections are made.
       * 
       * cupSelect - Array holding the selected cup sizes.
       * cupSizeSelect - Array holding the selected band sizes.
    */
    sizeGoNextStepBra(){
        const self = this;
        this.setFlag = true;
        // Check if two selections have been made
        if ((this.cupSelect.length === 1) && (this.cupSizeSelect.length === 1)) {
          // save states
          this.store.dispatch({
            type: 'SET_BRA_CUP',
            payload: this.cupSelect[0]
          });
          this.store.dispatch({
            type: 'SET_BRA_MEASURE',
            payload: this.cupSizeSelect[0]
          });
          this.store.dispatch({
            type: 'SET_BRA_SIZE',
            payload: {sizeCupLetter: this.cupSizeSelect[0], sizeCup: this.cupSelect[0]}
          });

          // Handle next steps
          if(this.store.getState().stepsVisited.includes('eby-sub4-style-choose-bra')){

            self.stepTracker.nextClickHandler('eby-sub4-color');
          } else {
            self.stepTracker.nextClickHandler('eby-sub4-custom-box-product-one-bra');
          }

          // close
          this.setFlag = false;
          this.resetSizes();
        }
    }
    sizeGoNextStepSet(){
        const self = this;
        this.setFlag = true;

        if( this.cupSizeSelect.length === 1 && this.cupSelect.length === 1 ){

          const braSizeChar = braCupSizeToChars( this.cupSizeSelect[0], this.cupSelect[0]);
          
          if(typeof braSizeChar === 'boolean'){
            
            this.resetSizeSelections();
            this.resetSizes();
            M.toast({html: 'Please select the correct cup and band size according to our size guide.', classes: 'ebyAtcAlert error'});
            return 
          } else {
            // return if the chosen band and cup don't match 
            this.store.dispatch({
              type: 'SET_BRA_CUP',
              payload: this.cupSelect[0]
            });
            this.store.dispatch({
              type: 'SET_BRA_MEASURE',
              payload: this.cupSizeSelect[0]
            }); 
            this.store.dispatch({
              type: 'SET_BRA_SIZE',
              payload: braSizeChar
            });
          }
        }
      
        if ((this.cupSelect.length === 1) && (this.cupSizeSelect.length === 1) && (this.pantySizeSelect.length === 2)) {
          // save state
          this.store.dispatch({
            type: 'SET_PANTY_SIZE',
            payload: this.pantySizeSelect[1]
          });
          this.store.dispatch({
            type: 'SET_PANTY_MEASURE',
            payload: this.pantySizeSelect[0]
          });        
          
          // Handle next steps
          if(this.store.getState().stepsVisited.includes('eby-sub4-style-set-bra')){

            self.stepTracker.nextClickHandler('eby-sub4-color');
          } else {

            self.stepTracker.nextClickHandler('eby-sub4-custom-box-product-set');
          }

          // close
          this.setFlag = false;
          this.resetSizes()
        }
    }
    sizeGoNextStep(nextStepId){
      const self = this;
      
      if(this.pantySizeSelect.length > 2){
        this.pantySizeSelect = this.pantySizeSelect.slice(-2); 
      }
        // Check if two selections have been made
        if (this.pantySizeSelect.length === 2) {
          // save state
          this.store.dispatch({
            type: 'SET_PANTY_SIZE',
            payload: this.pantySizeSelect[1]
          });
          this.store.dispatch({
            type: 'SET_PANTY_MEASURE',
            payload: this.pantySizeSelect[0]
          });

          // Handle next steps
          if(this.store.getState().styles !== 'custom'){
            self.stepTracker.nextClickHandler('eby-sub4-color');
          } else {
            self.stepTracker.nextClickHandler(nextStepId);
          }

          //close          
          this.setFlag = false
          this.resetSizes();
        }
    }
    resetSizes() {
        
        const braSizeElem = document.querySelector('.ebySubsAllNamesBoxSizeOneLetter');
        const braSizeElem2 = document.querySelector('.ebySubsAllNamesBoxSizeOne');

        const pantySizeElem = document.querySelector('.ebySubsAllNamesBoxSizePantyTwo');
        const pantySizeElem2 = document.querySelector('.ebySubsAllNamesBoxSizeTwo');
        
        if (braSizeElem) braSizeElem.textContent = ''; 
        if (braSizeElem2) braSizeElem2.textContent = ''; 
        if (pantySizeElem) pantySizeElem.textContent = ''; 
        if (pantySizeElem2) pantySizeElem2.textContent = ''; 
    }
    resetSizeSelections(){
        const sizeStore = this.store.getState().sizes

        if(sizeStore.braCup === null || sizeStore.braCup === null || sizeStore.braSizeChar == null){
          this.cupSelect = [];
          this.cupSizeSelect = [];
        }
        
        if(sizeStore.panty === null || sizeStore.pantyMeasure === null){ 
          this.pantySizeSelect = [];
        }
    }
  }
  /**
    * ControllerProductFetch
    * 
    * This controller is responsible for fetching products, creating individual 
    * product templates for display, and rendering these templates inside a specified 
    * container on the page. The template creation involves transforming product data 
    * into specific HTML structure to be presented in a grid layout for custom boxes.
  */
  class ControllerProductFetch {
    /**
      * Creates an instance of ControllerProductFetch.
      *
      * @param {UseCaseProductFetch} productFetchUseCase - Use case responsible for fetching products.
      * @param {string} parentCustomGrid - The ID of the parent HTML element where products will be appended.
    */
    constructor(productFetchUseCase, parentCustomGrid) {
      this.productFetchUseCase = productFetchUseCase;
      this.productContainer = document.getElementById(parentCustomGrid);
    }
    /**
      * Creates the product template given a product object.
      * 
      * Constructs an HTML structure that represents the product in a grid layout.
      *
      * @param {Object} product - The product data.
      * @returns {string} The HTML string for the product.
    */
    createProductTemplate(product, prdIndex) {
      if (!product.colorTag || !product.colorTag.includes('-')) return '';
      //console.log(product)
      const color = product.colorTag.split('-')[1].replace('_',' ');
      let style = vela.ebyProdTitleFormatter(product.title, 'style');

      const styleTypeBool = product.styleTag.includes('pantyType');
      const styleTypeFabric = product.styleTag.replace('pantyType-', '');
      
      if(styleTypeFabric.includes('braletteType-support_seamless')){
        style = 'Support Bra';
      } else if(product.prodType.includes('Sheer') && !styleTypeBool){
        style = 'Sheer Bra';
      } else if(styleTypeFabric.includes('braletteType-wireless_seamless')){
        style = 'Wireless Bra';
      }
      // console.log(':: rendering product for cbopts ::', vela.subFour);
      let prodVarIdObj = !!vela.subFour.cbopts.prodInventoryData ? vela.subFour.cbopts.prodInventoryData.filter((prod) => {return prod.prodId === product.id})[0] : {},
          prodVarId = "",
          isHidden = "";

      // if we have stock pulled in size, and there is no matching id in stock, hide the product
      if (!!prodVarIdObj) {
        prodVarId = prodVarIdObj.variantId;
      }
      if (prodVarId === "") {
        isHidden = "hidden";
      }
      
      return `
        <div class="eby-subs-custom-box-grid-item eby-subs-custom-move-itemin-box ${isHidden}" data-prodname="${style}" data-prodstyle="${product.styleTag.replace('pantyType-', '')}" data-prodid="${product.id}" data-prodcolor="${product.colorTag.split('-')[1]}" data-prodvarid="${prodVarId}" data-prodimg="${product.prodImage.src}" data-prodtype="${product.prodType}">
          <div class="eby-subs-custom-box-flx-img-txt">
            <div data-forelem="ele-styleGroup_custom_p${prdIndex}" class="eleOptLabel">
              <div class="eby-subs-custom-box-img23">
                <img alt="panty" title="${style}" class="custom-box-src-img" src="${product.prodImage.src}"/>    
              </div>
              <div class="eby-subs-custom-box-text">
                <div class="eby-subs-custom-box-txt-wrp23">
                  <div class="eby-subs-custom-box-txt1">
                    <span class="eby-subs-custom-box-stylepdp eby-subs---custom---name">${style}</span>
                    <span class="eby-subs-custom-box-stylepdp eby-subs---custom---fabric">${color}</span>
                  </div>
                </div>
              </div>
              <input id="ele-styleGroup_custom_p${prdIndex}" class="with-gap" name="ele-styleGroup_custom_p${prdIndex}-${product.id}" value="${product.prodImage.id}" data-val="${product.prodImage.id}" data-stylecopy="Custom: Select Item" type="checkbox" />
            </div>
          </div>
        </div>`;
    }
    /**
      * Fetches the products, creates their templates, and appends them to the container.
    */
    async renderProducts() {
      const products = await this.productFetchUseCase.getProducts('panty');
      const filterProducts = products.filter(product => !product.title.includes("Bra"));
      // 
      const productTemplates = filterProducts.map((product, index) => this.createProductTemplate(product, index));
      this.productContainer.innerHTML = productTemplates.join('');
    }
    
    async renderProductsSet() {
      const products = await this.productFetchUseCase.getProducts('set');
      const filterProducts = products.filter(product => product.title.includes("Bra"));
      const productTemplates = filterProducts.map((product, index) => this.createProductTemplate(product, index));
      this.productContainer.innerHTML = productTemplates.join('');
    }
    async renderProductsSetPanty() {
      const products = await this.productFetchUseCase.getProducts('set');
      const filterProducts = products.filter(product => !product.title.includes("Bra"));
      const productTemplates = filterProducts.map((product, index) => this.createProductTemplate(product, index));
      this.productContainer.innerHTML = productTemplates.join('');
    }
  }
  /**
    * ControllerCustomProduct
    * 
    * This controller serves as an orchestrator that brings together the product fetching use case 
    * and the controller that renders the products. It essentially bridges the gap between data fetching 
    * and the visual representation of that data. Its main task is to kick off the process of 
    * displaying products for the custom box on the page.
  */
  class ControllerCustomProduct {
    constructor(url, parentCustomGridId, store) {
      this.store = store;
      this.productFetchUseCase = new UseCaseProductFetch(url, this.store);
      this.productFetchController = new ControllerProductFetch(this.productFetchUseCase, parentCustomGridId);
    }
  
    async renderProducts() {
      await this.productFetchController.renderProducts();
    }
    async renderProductsSet() {
      await this.productFetchController.renderProductsSet();
    }
    async renderProductsSetPanty() {
      await this.productFetchController.renderProductsSetPanty();
    }
  }
  class CustomBoxImgController {

    constructor(elements){
        this.elements = elements;
        this.flag = false
    }

    uploadImg(index, newImg){
        const newImgElem = document.createElement('img');
        const closeButtonImg = document.createElement('img');

        newImgElem.src = newImg;  
        newImgElem.className = 'custom-box-img23-wrapper';
        closeButtonImg.src = 'https://cdn.shopify.com/s/files/1/0313/4062/5964/files/Button_-_Close_1.png?v=1703031176';
        closeButtonImg.alt = 'Close';
        closeButtonImg.className = 'subs4-custom-close-button';

        console.warn('Fix this class to not instantiate more then once after reseting' ,this.elements[index])
        let parentElement = this.elements[index];
        // Check if an <img> tag exists and has a non-empty 'src' attribute
        let imgChild = parentElement.querySelector('img');
        if (imgChild && imgChild.src) {
            // If true, return early to "do nothing"
            return;
        }
        
        this.elements[index].appendChild(newImgElem);
        this.elements[index].appendChild(closeButtonImg);
    }

    remove(store, elementId){
        // Select the image by its ID
        const myImage = document.querySelectorAll(`#${elementId} .eby-subs-custom-box-color-item`);
        // Add a click event listener
        myImage.forEach( el => el.addEventListener('click', (event) => {

            const indexRemove = +event.target.dataset.j;

            if(myImage[indexRemove].innerHTML === ''){
                const elemAlert = document.querySelector('.custom-box-alrt-msg24')

                elemAlert.classList.remove('hide');
                setTimeout(() => {
                  elemAlert.classList.add('hide');
                }, 2000); 
            }

            myImage[indexRemove].innerHTML = '';
            
            store.dispatch({
              type: 'REMOVE_PRODUCTS',
              payload: indexRemove
            });
            this.updateSetsGrid(indexRemove);
        }))
    }

    resetContainers(){
      for(const element of this.elements){
      
        const imageExist = element.querySelector('img');
        if(imageExist){

          imageExist.textContent = '';
        
        }  
      } 
    }
    
    updateTextTitle(type){
      const braElem = document.querySelector('#set-box-cu-slot_one');
      const pantyElem = document.querySelector('#set-box-cu-slot_two');
      if(type === 'bra'){
        braElem.classList.remove('hidden');
        pantyElem.classList.add('hidden');
      } else {
        braElem.classList.add('hidden');
        pantyElem.classList.remove('hidden');
      }
    }
    
    updateSetsGrid(index){
      if(index == 0){
        this.updateTextTitle('bra');
        document.querySelector('#custom-box-grid-setBraOnly').classList.remove('hide');
        document.querySelector('#custom-box-grid-setPantyOnly').classList.add('hide');
      } else if(index == 1) {
        this.updateTextTitle('panty');
        document.querySelector('#custom-box-grid-setBraOnly').classList.add('hide');
        document.querySelector('#custom-box-grid-setPantyOnly').classList.remove('hide');
      } else {
        console.warn('Tried hiding a bra or panty grid but index is neither 0 or 1', index)
      }
    }
  }
  /*
    * Custom box controller
  */
  class CustomHandlerController {
    /**
      * Constructs the CustomHandlerController with the necessary trackers and controllers.
      * 
      * @param {ControllerStepStack} stepTracker - Responsible for tracking the current step in the UI flow.
      * @param {PlanSelectionController} PlanSelectionController - Controller responsible for plan selection actions.
    */
    constructor(stepTracker, store, SummaryController) {
      this.stepTracker = stepTracker;
      this.store = store;
      this.summaryController = SummaryController; 
      this.handleProductClick = this.handleProductClick.bind(this);
      this.handleRemoveClick = this.handleRemoveClick.bind(this);
    }
    
    handleProductSelection(productSelectClass, containerId, nextStepId) {
      const productContainer = document.getElementById(containerId);
      const self = this;

      if (productContainer) {
        
        const productImgViewer = new CustomBoxImgController([document.querySelector('#eby-subs-custom-color-cru-controller-0'), document.querySelector('#eby-subs-custom-color-cru-controller-1'), document.querySelector('#eby-subs-custom-color-cru-controller-2')]);
        const boundClickHandler = (event) => self.handleProductClick(event, productSelectClass, containerId, nextStepId, productContainer, productImgViewer);
        productContainer.addEventListener('click', boundClickHandler);      
        productImgViewer.remove(this.store, 'eby-sub4-custom-box-product');
      }
    }
    
    handleProductClick(event, productSelectClass, containerId, nextStepId, productContainer, productImgViewer){
      // Check if the click event target was a product box
      const box = event.target.closest(productSelectClass);
      if (box && productContainer.contains(box)) {
        // Toggle the selection
        box.classList.toggle('selected');
        
        const elemImage = box.querySelector('img');
        // Track the selection custom box add object
        const productData = {
            productId: box.dataset.prodvarid,
            productName: box.dataset.prodname,
            productColor: box.dataset.prodcolor,
            productImg: elemImage.src,
            variantId: box.dataset.prodvarid
        };
        
        
        // Check if three selections have been made
        const currentProducts = this.store.getState();
        const productIndex = currentProducts.products.length;
        const addAtIndex  = currentProducts.products.findIndex((product) => Object.keys(product).length === 0);
        const deltaIndex = addAtIndex === -1 ? 0 : addAtIndex; 
        const totalProductsAddedBefore  = currentProducts.products.filter((product) => Object.keys(product).length > 0).length
        
        if(totalProductsAddedBefore < 3){
          if(addAtIndex === -1){
            this.store.dispatch({
                type: 'SET_PRODUCTS',
                payload: productData
            });
          } else {
            this.store.dispatch({
                type: 'ADD_PRODUCTS',
                payload: productData
            });
          }
          productImgViewer.uploadImg(deltaIndex, elemImage.src);
        } 
        
        const afterAddingProducts = this.store.getState();
        
        const totalProductsAdded  = afterAddingProducts.products.filter((product) => Object.keys(product).length > 0).length;
        if (totalProductsAdded === 3) {
          this.updateProductReview(productIndex , elemImage.src, currentProducts.products, this.store, 'eby-sub4-custom-box-list-pds', containerId, this.stepTracker);
          ControllerComponent.hideComponent(this.stepTracker.getCurrentStep())
          this.stepTracker.goToStep(nextStepId, '');
          ControllerComponent.showComponent(nextStepId);
        }
      }
    }

    handleProductSelectionBra(productSelectClass, containerId, nextStepId) {
      const self = this;
      const productContainer = document.getElementById(containerId);
      
      if (productContainer) {
        
        const productImgViewer = new CustomBoxImgController([document.querySelector('#eby-subs-custom-bra-color-cru-controller-0')]);
        productContainer.addEventListener('click', (event) => {
          // Check if the click event target was a product box
          
          const box = event.target.closest(productSelectClass);
          if (box && productContainer.contains(box)) {
            // Toggle the selection
            box.classList.toggle('selected');
            
            const elemImage = box.querySelector('img');
            // Track the selection custom box add object
            const productData = {
                productId: box.dataset.prodvarid,
                productName: box.dataset.prodname,
                productColor: box.dataset.prodcolor,
                productImg: elemImage.src,
                variantId: box.dataset.prodvarid
            };
            
            // Check if three selections have been made
            const currentProducts = self.store.getState();
            const productIndex = currentProducts.products.length;
            const addAtIndex  = currentProducts.products.findIndex((product) => Object.keys(product).length === 0);
            const deltaIndex = addAtIndex === -1 ? 0 : addAtIndex; 
            const totalProductsAddedBefore  = currentProducts.products.filter((product) => Object.keys(product).length > 0).length;
            
            if(totalProductsAddedBefore < 1){
              if(addAtIndex === -1){
                self.store.dispatch({
                    type: 'SET_PRODUCTS',
                    payload: productData
                });
              } else {
                self.store.dispatch({
                    type: 'ADD_PRODUCTS',
                    payload: productData
                });
              }
              productImgViewer.uploadImg(deltaIndex, elemImage.src);
            }
            const afterAddingProducts = this.store.getState();
            const totalProductsAdded  = afterAddingProducts.products.filter((product) => Object.keys(product).length > 0).length;

            if (totalProductsAdded === 1) {
              self.updateProductReview(productIndex , elemImage.src, currentProducts.products, self.store, 'eby-sub4-custom-box-list-bra', productImgViewer, containerId);
              ControllerComponent.hideComponent(self.stepTracker.getCurrentStep())
              self.stepTracker.goToStep(nextStepId);
              ControllerComponent.showComponent(nextStepId);
            }
          }
        });
        productImgViewer.remove(self.store, 'eby-sub4-custom-box-product-one-bra');
      }
    }

    updateTextTitle(type){
      const braElem = document.querySelector('#set-box-cu-slot_one');
      const pantyElem = document.querySelector('#set-box-cu-slot_two');
      if(type === 'bra'){
        braElem.classList.remove('hidden');
        pantyElem.classList.add('hidden');
      } else {
        braElem.classList.add('hidden');
        pantyElem.classList.remove('hidden');
      }
    }

    handleProductSelectionSet(productSelectClass, containerId, nextStepId) {
      const self = this;
      const productContainer = document.getElementById(containerId);
      
      //console.log(':: set box is listening and firing ::');

      if (productContainer) {
        
        const productImgViewer = new CustomBoxImgController([document.querySelector('#eby-subs-custom-bra-set-color-cru-controller-0'), document.querySelector('#eby-subs-custom-bra-set-color-cru-controller-1')]);
        productContainer.addEventListener('click', (event) => {
          // Check if the click event target was a product box
          
          const box = event.target.closest(productSelectClass);
          if (box && productContainer.contains(box)) {
            // Toggle the selection
            box.classList.toggle('selected');
            
            const elemImage = box.querySelector('img');
            // Track the selection custom box add object
            const productData = {
                productId: box.dataset.prodvarid,
                productName: box.dataset.prodname,
                productColor: box.dataset.prodcolor,
                productImg: elemImage.src,
                variantId: box.dataset.prodvarid
            };

            // Check if three selections have been made
            const currentProducts = self.store.getState();
            const productIndex = currentProducts.products.length;
            const addAtIndex  = currentProducts.products.findIndex((product) => Object.keys(product).length === 0);
            const deltaIndex = addAtIndex === -1 ? 0 : addAtIndex; 
            const totalProductsAddedBefore  = currentProducts.products.filter((product) => Object.keys(product).length > 0).length;
            
            if(totalProductsAddedBefore < 2){
              
              if(addAtIndex === -1){
                self.store.dispatch({
                    type: 'SET_PRODUCTS',
                    payload: productData
                });
              } else {
                self.store.dispatch({
                    type: 'ADD_PRODUCTS',
                    payload: productData
                });
              }
              productImgViewer.uploadImg(deltaIndex, elemImage.src);
            }

            const afterAddingProducts = this.store.getState();

            const totalProductsAdded  = afterAddingProducts.products.filter((product) => Object.keys(product).length > 0).length
            
            if(totalProductsAdded === 1){
              this.updateTextTitle('panty');
              // updates after choosing bra 
              document.querySelector('#custom-box-grid-setBraOnly').classList.add('hide')
              document.querySelector('#custom-box-grid-setPantyOnly').classList.remove('hide')
            }
            if (totalProductsAdded === 2) {

              const nonEmptyProduct = currentProducts.products.find(product => Object.keys(product).length > 0);
              const validateItems = validateSetProducts(productData.productName, nonEmptyProduct.productName);

              if(!validateItems){
                M.toast({html: 'Please choose a Bra and Panty!', classes: 'toast ebyAtcAlert error'});
                console.error("Validation didn't pass please fix items data: ",afterAddingProducts);
                return
              }
              
              self.updateProductReview(productIndex , elemImage.src, currentProducts.products, self.store, 'eby-sub4-custom-box-list-set');
              ControllerComponent.hideComponent(self.stepTracker.getCurrentStep())
              self.stepTracker.goToStep(nextStepId);
              ControllerComponent.showComponent(nextStepId);
            }
            
          }
        });
        productImgViewer.remove(self.store, 'eby-sub4-custom-box-product-set');
      }
    }

    updateProductReview(borrar, newImg, products, box, elemId, circleViewr, parentId){
        const elementsReview = document.querySelectorAll(`#${elemId} .type1-box-type-clmn3s`);

        const storeObj = box.getState();

        if (storeObj.styles === "bra-custom") {
          this.updateElements(elementsReview, storeObj,  elemId);
        } else {
          this.updateElements(elementsReview, storeObj,  elemId);
        }
        this.bindRemoveEvents(elemId, elemId)
    }

    bindRemoveEvents(elemId, type) {
      const containers = document.querySelectorAll(`#${elemId} .type1-box-type-clmn3s`);
      containers.forEach((container, index) => {
        container.addEventListener('click', (event) => this.handleRemoveClick(event, index, type));
      });
    }

    handleRemoveClick(event, index, type) {
      const clickedElement = event.target.closest('.type1-box-type-clmn3s');
      if (clickedElement) {
        const getParentId = this.store.getState().stepsVisited.slice(-2);
        const myImage = document.querySelectorAll(`#${getParentId[0]} .eby-subs-custom-box-color-item`);

        if(myImage[index]) {
          myImage[index].innerHTML = '';

          this.store.dispatch({
            type: 'REMOVE_PRODUCTS',
            payload: index
          });

          ControllerComponent.hideComponent(this.stepTracker.getCurrentStep());
          this.stepTracker.goBack();
          ControllerComponent.showComponent(this.stepTracker.getCurrentStep());
        }
      }
      if(type === 'eby-sub4-custom-box-list-set'){
        this.updateSetsGrid(index);
      }
    }

    updateElements(elementsReview, storeObj, elemId) {
      elementsReview.forEach((elementImg, index) => {
        this.updateImageSource(elementImg, storeObj, index, elemId);
        this.updateTextContent(elementImg, storeObj, index, elemId);
      });
    }
    
    updateImageSource(elementImg, storeObj, index, elemId) {
      const imgSelector = storeObj.styles.includes('bra-custom') ? '#eby-sub4-custom-box-list-bra .sub-custm-rvw-img23-src' : '.sub-custm-rvw-img23-src';
      elementImg.querySelector(imgSelector).src = storeObj.products[index].productImg;
    }

    updateTextContent(elementImg, storeObj, index, elemId) {
      // const sizeText = elemId.includes('eby-sub4-custom-box-list-pd') ? `${storeObj.sizes.panty} (${storeObj.sizes.pantyMeasure})` : `${storeObj.sizes.braSizeChar.toUpperCase()} (${storeObj.sizes.braCup}${storeObj.sizes.braMeasure.toUpperCase()})`;
      const elemPanties = elemId.includes('eby-sub4-custom-box-list-pd');
      const elemBraOrSets = elemId.includes('eby-sub4-custom-box-list-bra') || elemId.includes('eby-sub4-custom-box-list-set');
      let sizeText = '';

      if (elemPanties) {
        sizeText = `${storeObj.sizes.panty} (${storeObj.sizes.pantyMeasure})`;
      } else if (elemBraOrSets) {
        sizeText = `${storeObj.sizes.braSizeChar.toUpperCase()} (${storeObj.sizes.braCup}${storeObj.sizes.braMeasure.toUpperCase()})`;
        if (elemId.includes('eby-sub4-custom-box-list-set') && index === 1) {
          sizeText = `${storeObj.sizes.panty} (${storeObj.sizes.pantyMeasure})`;
        }
      } else {
        console.warn('Tried adding text on the review pannel but no element was found ->', elemId);
        return;
      }

      // Set text content in one place
      elementImg.querySelector('.CustomReviewSize').textContent = sizeText; 
      elementImg.querySelector('.customReviewStyle').textContent = storeObj.products[index].productName;
      elementImg.querySelector('.customReviewColor').textContent = storeObj.products[index].productColor;
    }    

    updateSetsGrid(index){
      if(index == 0){
        document.querySelector('#custom-box-grid-setBraOnly').classList.remove('hide');
        document.querySelector('#custom-box-grid-setPantyOnly').classList.add('hide');
      } else if(index == 1) {
        document.querySelector('#custom-box-grid-setBraOnly').classList.add('hide');
        document.querySelector('#custom-box-grid-setPantyOnly').classList.remove('hide');
      } else {
        console.warn('Tried hiding a bra or panty grid but index is neither 0 or 1', index)
      }
    }

    handleProductRemoveToSummary(clickedId, nextComponentId){
      const self = this;
      
      document.getElementById(clickedId).addEventListener('click', (event) => {

        // Handle next steps
        const controllerNext = new ControllerNextComponent(self.stepTracker.getCurrentStep());
        controllerNext.activateButton();
        //controllerNext.goNext(nextComponentId, self.stepTracker);
        self.stepTracker.goNext(nextComponentId);

        //self.summaryController.update(self.box);
        // Update the summary for the custom box
        const currentState = self.store.getState();
        self.summaryController.update(currentState);
      }, true);
    }
  }
  /*
    ****************************************************
    * SUMMARY
    ****************************************************
  */
  class SummaryController {
    constructor(store) {
      this.store = store
      this.summaryElement = document.querySelector('#eby-sub4-summary');
      this.priceElems = this.summaryElement.querySelectorAll('.ebySubsAllNamesBoxPrice');
      this.renewsAt = this.summaryElement.querySelector('.ebySubsAllNamesRenews');
      this.styleElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxHowMany');
      this.colorElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxColor');
      this.sizeOneLetterElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxSizeOneLetter');
      this.sizeOneElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxSizeOne');
      this.sizeTwoLetter = this.summaryElement.querySelector('.ebySubsAllNamesBoxSizePantyTwo');
      this.discountElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxDiscount');
      this.descriptionElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxDescription');
      this.sizeTwoElem = this.summaryElement.querySelector('.ebySubsAllNamesBoxSizeTwo');
      this.discountPerk = this.summaryElement.querySelector('.ebySubsAllNamesBoxDiscountPerk');
      this.imgLoader = this.summaryElement.querySelector('.summryImgLoader');
      // Add more if needed
      this.customStyle = '';
      this.braNameType = this.summaryElement.querySelector('.ebySubsAllNamesBoxTypeBra');
    }

    formatLowerDash(value){
      let newValue = value || '';
      if(newValue.includes('_')){
        return newValue.replace('_', ' ');
      } 
      return newValue
    }

    update(currentState) {
        // Update prices
        this.priceElems.forEach(elem => elem.textContent = currentState.currentBox?.price || '');
        // Area of improvement we could make this better
        if(currentState.boxType === 'classic_box'){
            this.customStyle =  '3 Panties';
            this.styleElem.textContent = this.customStyle;
        } else if(currentState.boxType === 'bra_box') {
            this.customStyle = '1 Bra';
            this.styleElem.textContent = this.customStyle;
        } else if(currentState.boxType === 'set_box') {
            this.customStyle =  'Choose My Own';
            this.braNameType.textContent = 'Matching Set';
            this.styleElem.textContent = this.customStyle;
        }

        if(currentState.boxType === 'classic_box' && currentState.currentBox.box !== "class_box_bra"){
          this.sizeOneLetterElem.textContent =  `${currentState.sizes.panty} `;
          this.sizeOneElem.textContent =  `(${currentState.sizes.pantyMeasure})`;
        } else if (currentState.boxType === 'classic_box' && currentState.currentBox.box === "class_box_bra"){
          this.sizeOneLetterElem.textContent =  currentState.sizes.braSizeChar;
          this.sizeOneElem.textContent =  ` (${currentState.sizes.braCup + currentState.sizes.braMeasure})`;
        } else if (currentState.boxType === 'bra_box'){
          this.sizeOneLetterElem.textContent =  currentState.sizes.braSizeChar;
          this.sizeOneElem.textContent =  ` (${currentState.sizes.braCup + currentState.sizes.braMeasure})`;
        } else {
          this.sizeOneLetterElem.textContent =  currentState.sizes.braSizeChar;
          this.sizeOneElem.textContent = ` (${currentState.sizes.braCup + currentState.sizes.braMeasure}), `;
          this.sizeTwoLetter.textContent =  `${currentState.sizes.panty} `;
          this.sizeTwoElem.textContent = `(${currentState.sizes.pantyMeasure})`
        }
        // check safety
        if(currentState.currentBox && Object.keys(currentState.currentBox).length > 1){
        
          if( currentState.currentBox.box === "classic_box_custom" ){
            this.colorElem.textContent = this.formatLowerDash(currentState.currentBox.color);
          } else {
            this.colorElem.textContent = this.formatLowerDash(currentState.colors);
          }

          if(currentState.currentBox.box.includes('custom')) {
              this.styleElem.textContent =  'Choose Your Own';
              this.colorElem.textContent = this.customStyle;
          } 

          
          this.discountElem.textContent = currentState.currentBox.discount;
          this.descriptionElem.textContent = currentState.currentBox.description;
          this.renewsAt.textContent = currentState.currentBox.renewalPrice;
          this.discountPerk.textContent = currentState.currentBox.memberDesc;
          this.imgLoader.src = currentState.currentBox.summaryImg;
          
          this.updateBraPrice(currentState);
        }
    }

    updateBraPrice(box){   
        // check if we are in a single bra subscription
        if(box.boxType.includes('bra') || box.setBraOpt.includes('bra')){
          const typeBra = box.setBraOpt

          if(typeBra.includes('sheer')){
            // this.priceElems.textContent = box.currentBox?.braPrices.sheer || '';
            this.priceElems.forEach(elem => elem.textContent =  box.currentBox?.braPrices.sheer || '');
            this.renewsAt.textContent = box.currentBox?.braPrices.sheer || '';
            this.discountElem.textContent = box.currentBox?.discountBra.sheer || '';
            
          } else if(typeBra.includes('support')){
            this.priceElems.forEach(elem => elem.textContent =  box.currentBox?.braPrices.support || '');
            this.renewsAt.textContent = box.currentBox?.braPrices.support || '';
            this.discountElem.textContent = box.currentBox?.discountBra.support || '';
            this.braNameType.textContent = `${typeBra.split('_')[0]} bra`;
            
          } else if(typeBra.includes('only')){
            this.priceElems.forEach(elem => elem.textContent =  box.currentBox?.braPrices.only || '');
            this.renewsAt.textContent = box.currentBox?.braPrices.only || '';
            this.discountElem.textContent = box.currentBox?.discountBra.only || '';
            this.braNameType.textContent = `${typeBra.split('_')[0]} bra`;
            
          }
        } 
    } 
  }

  /**
    * The ColorSelectionController manages the selection of colors for different box plans.
    * It's responsible for updating the UI upon a color selection, moving the process
    * to the next step, and updating the current box's color.
  */
  class ColorSelectionController {
    /**
      * Constructs the ColorSelectionController with the necessary trackers and controllers.
      * 
      * @param {ControllerStepStack} stepTracker - Responsible for tracking the current step in the UI flow.
      * @param {PlanSelectionController} PlanSelectionController - Controller responsible for plan selection actions.
    */
    constructor(stepTracker, store, SummaryController) {
      this.stepTracker = stepTracker;
      this.store = store;

      this.colorSelected = false; // Initialize flag
      this.unsubscribe = this.store.subscribe(() => this.handleStateChange());
      this.summaryController = SummaryController; 
    }

    handleStateChange() {      
      const currentState = this.store.getState();
      // Only update if the color has been selected
      if (this.colorSelected) {
        this.summaryController.update(currentState);  // Pass the current products to the update method
      }
    }

    handleColorSelection(clickedId, nextComponentId) {
      const self = this;

      document.getElementById(clickedId).addEventListener('click', (event) => {
        
        self.colorSelected = true;
        // trigger style controlle 
        ControllerElementStyle.hideElementTriggered(self.stepTracker.getCurrentStep());
        ControllerElementStyle.showElementTriggered(clickedId);
        // Handle next steps
        const controllerNext = new ControllerNextComponent(self.stepTracker.getCurrentStep());
        controllerNext.activateButton();
        
        const inputElement = event.currentTarget.querySelector('input');

        if (inputElement) {
          self.stepTracker.nextClickHandler(nextComponentId);
          self.store.dispatch({
            type: 'SET_COLORS',
            payload: inputElement.value
          });
          
        } else {
          console.error('No input in Color')
        }

      }, true);
    }
  }